<template>
    <div class="operation_box">
        <!-- Document Download -->
        <div class="operation_item">
            <el-dropdown split-button type="primary"
                         @click="handleDocumentsDownload"
                         @command="handleActionCommand"
            >
                <i class="fa fa-cloud-download"></i>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item icon="fa fa-cloud-download" :command="handleDocumentsDownload">
                        <span>{{ $t("common.all") }}</span>
                    </el-dropdown-item>
                    <el-dropdown-item v-for="(enumProp, enumValue) in enumDef.assignmentDocumentType.properties"
                                      :key="enumValue"
                                      :icon="enumProp.icon">
                        <a :href="buildDocumentDownloadUrl(Number(enumValue))" target="_blank">
                            {{ $t(enumProp.key) }}
                        </a>
                    </el-dropdown-item>
					<el-dropdown-item v-if="this.params.data.tciContractFileId" icon="fa fa-file-pdf-o">
						<a :href="buildDownloadUrl(this.params.data.tciContractFileId)" target="_blank">
							{{ $t("common.data.assignmentDocumentType.tciContract") }}
						</a>
					</el-dropdown-item>
					<el-dropdown-item v-if="this.params.data.isBundleWithTCI" icon="fa fa-file-pdf-o" :command="handleTCIDocumentsForBundleDownload">
						<span>{{ $t("common.data.assignmentDocumentType.tciContracts") }}</span>
					</el-dropdown-item>
				</el-dropdown-menu>
            </el-dropdown>
        </div>
        <!-- Table Actions -->
        <div class="operation_item" v-if="allowedActions.length > 0">
            <el-dropdown @command="handleActionCommand">
                <el-button type="primary">
                    {{$t("common.more")}}<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="action in allowedActions"
                                      :key="action.key"
                                      :icon="action.icon"
                                      :command="action.execute">
                        {{ $t(action.key) }}
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>
<script>

import {enumDef} from "@/common/enumDefs";
import {fileuploadApi} from "@/common/api/fileuploadApi";

export default {
    data() {
        return {
            enumDef: enumDef,
            actionList: [
                {
                    key: "common.resell",
                    icon: "fa fa-paper-plane",
                    isEnabled: () => { return this.params.data.isResellAllowed === true; },
                    execute: () => { this.params.showResellModal(this.params.data); }
                },
                {
                    key: "common.requestIpu",
                    icon: "fa fa-file-signature",
                    isEnabled: () => { return this.params.data.canRequestIPU === true; },
                    execute: () => { this.params.requestIpu(this.params.data); }
                }
            ]
        };
    },
    computed: {
        allowedActions() {
            return this.actionList.filter(action => action.isEnabled());
        }
    },
    methods: {
        handleTCIDocumentsForBundleDownload() {
            let postData = {
                assignmentId: this.params.data.assignmentId,
                needTci: true
            };
            this.params.downloadDocuments(postData);
        },
        handleDocumentsDownload() {
            let postData = {
                assignmentId: this.params.data.assignmentId,
                needAssignment: true,
                needAdviceOfSettlement: true,
                needServiceInvoice: true,
                needTransactionDocument: true,
                needCsv: true,
                needTci: true
            };
            this.params.downloadDocuments(postData);
        },
        handleActionCommand(command) {
            if (command) {
				command()
			}
        },
        buildDocumentDownloadUrl(documentType) {
            let fileId;

            switch (documentType) {
                case enumDef.assignmentDocumentType.AssignmentContract:
                    fileId = this.params.data.assignmentDocumentFileId;
                    break;
                case enumDef.assignmentDocumentType.AdviceOfSettlement:
                    fileId = this.params.data.assignmentInvoiceDocumentFileId;
                    break;
                case enumDef.assignmentDocumentType.ServiceInvoice:
                    fileId = this.params.data.assignmentServiceInvoiceDocumentFileId;
                    break;
                case enumDef.assignmentDocumentType.TransactionPdf:
                    fileId = this.params.data.assignmentTransactionDocumentFileId;
                    break;
                case enumDef.assignmentDocumentType.AccountingCsv:
                    fileId = this.params.data.accountingCsvDocumentFileId;
                    break;
            }

            return fileuploadApi.getPdfUrl(fileId);
        },
		buildDownloadUrl(fileId) {
			return fileuploadApi.getPdfUrl(fileId);
		},
    }
};
</script>